<template>
  <div class="dashboard-block" v-if="!booking.is_offer">
    <h2>Notes</h2>

    <notes-list :notes="notes" @addNote="addNote" @deleteNote="deleteNote" @pin="(id) => { pinNote({ bookingId: booking.id, noteId: id }) }"  />

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import NotesList from '../notes/NotesList'

export default {
  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  components: {
    NotesList
  },

  data () {
    return {
      text: null,
      viewingAll: false
    }
  },

  computed: {
    ...mapState('booking/note', ['notes'])
  },

  created () {
    if (!this.booking.is_offer) {
      this.getBookingNotes(this.booking.id)
    }
  },

  methods: {
    ...mapActions('booking/note', ['getBookingNotes', 'storeBookingNote', 'removeNote', 'pinNote']),

    addNote (text) {
      return this.storeBookingNote({
        id: this.booking.id,
        payload: {
          text: text,
          user: this.$user
        }
      })
    },

    deleteNote (note) {
      return this.removeNote({
        id: this.booking.id,
        noteId: note.id
      })
    }
  }
}
</script>
